import * as yup from 'yup';


import {PLATFORM_LOCALE_TAGS} from '../i18nConstants';


export const SCHEMA_PLATFORM_LANGUAGE = yup.string()
    .nullable()
    .oneOf(PLATFORM_LOCALE_TAGS)
    .required();
